<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Tell us about your business</h3>
                    </div>
                    <div class="card-body">
                        <p class="card-text bold fs-17">Gender and Development</p>
                        <p class="card-text text-justify">Please indicate whether the business has:</p>

                         <div  class="row">
                            <div class="col-6" v-for="(item, index) in ref_gad" :key="index">
                                <div class="icheck-primary d-inline">
                                    <input
                                        type="checkbox"
                                        :id="'c' + item.id"
                                        :value="item.id"
                                        v-model="gad">
                                    <label :for="'c' + item.id">{{ item.item_desc }}</label>
                                </div>
                            </div>
                        </div>
                        <!--
                        <div class="row">
                            <div class="col-4">
                                <div class="icheck-primary d-inline">
                                    <input type="checkbox" id="c1" value="1" v-model="gad">
                                    <label for="c1">Female Manager/s</label>
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="icheck-primary d-inline">
                                    <input type="checkbox" id="c2" value="2" v-model="gad">
                                    <label for="c2">Female head officer for operations/administrative services</label>
                                </div>
                            </div>
                        </div>
                        -->
                        <hr>
                        <p class="card-text"><b class="fs-17">Number of Employees</b> <span>(Please indicate all paid employees and/or directlyinvolved in business operations)</span></p>

                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Full Time</label>
                                    <input type="number" class="form-control" id="i1" v-model="loan_req.current_reg">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Part-time/Contractual</label>
                                    <input type="number" class="form-control" id="i2" v-model="loan_req.current_contract">
                                </div>
                            </div>

                            <div class="col-4"></div>
                        </div>
                        <hr />
                        <p class="card-text bold fs-17">Top Trade References</p>
                        <div>
                            <div class="row" v-for="(i, index) in suppliers" :key="index">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Name of Top Suppliers</label>
                                        <input type="text" class="form-control text-uppercase" v-model="i.name">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Goods Supplied/Services Rendered</label>
                                        <input type="text" class="form-control text-uppercase" v-model="i.goods">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Contact Person</label>
                                        <input type="text" class="form-control text-uppercase" v-model="i.con_person">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div>
                                        <label class="d-block">Contact Number</label>
                                        <div role="group" class="form-group" style="display: flex; align-items: center;">
                                            <input type="text" class="form-control" v-model="i.con_number">
                                            <button class="btn btn-outline-danger ml-1" @click="removeRowSup(index)" v-if="suppliers.length > 1">Remove</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-right">
                                <button class="btn text-nowrap btn-outline-primary" @click="addRowSup()">
                                    Add Row
                                </button>
                            </div>
                        </div>
                        <hr />
                        <div>
                            <div class="row" v-for="(i, index) in customers" :key="index">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Name of Top Customers</label>
                                        <input type="text" class="form-control text-uppercase" v-model="i.name">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Goods Purchased/Service Availed</label>
                                        <input type="text" class="form-control text-uppercase" v-model="i.goods">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Contact Person</label>
                                        <input type="text" class="form-control text-uppercase" v-model="i.con_person">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div>
                                        <label class="d-block">Contact Number</label>
                                        <div role="group" class="form-group" style="display: flex; align-items: center;">
                                            <input type="text" class="form-control" v-model="i.con_number">
                                            <button class="btn btn-outline-danger ml-1" @click="removeRowCus(index)" v-if="customers.length > 1">Remove</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-right">
                                <button class="btn text-nowrap btn-outline-primary" @click="addRowCus()">
                                    Add Row
                                </button>
                            </div>
                        </div>

                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                        <button class="btn btn-primary float-right" @click="apiSubmit()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>

        </div>
    </transition>
</template>
<script>
    import {
        apiPostGadTradeRef,
        apiGetTradeData,
    } from "@js/api/applyLoanApi";

    export default {
        components: {},
        props: ['app_id'],
        data() {
            return {
                gad: [],
                ref_gad: [],

                loan_req: {
                    current_reg: null,
                    current_contract: null
                },


                suppliers: [{
                    name: null,
                    goods: null,
                    con_person: null,
                    con_number: null,
                }],
                customers: [{
                    name: null,
                    goods: null,
                    con_person: null,
                    con_number: null,
                }],
                api: {
                    post: false,
                    update: false,
                    ref: false,
                },
            }
        },

        validations: {},
        created() {
            this.getGadTradeData();
        },
        methods: {

            async getGadTradeData() {
                try {
                    this.$emit('load', 1);
                    const data = await apiGetTradeData(this.app_id);
                    this.loan_req = data.loan_req;
                    this.gad = data.gad;
                    this.ref_gad = data.ref_gad

                    if (data.suppliers.length) {
                        this.suppliers = data.suppliers
                    }
                    if (data.customers.length) {
                        this.customers = data.customers
                    }
                } catch (error) {
                    this.$emit('error', error);
                } finally {
                    this.$emit('load', -1);
                }

            },
            async apiSubmit() {
                let a = _.some(this.suppliers, obj =>
                    _.some(_.values(obj), value => !_.isEmpty(value))
                );

                let b = _.some(this.customers, obj =>
                    _.some(_.values(obj), value => !_.isEmpty(value))
                );

                const form = {
                    application_id: this.app_id,
                    gad: this.gad,
                    current_reg: this.loan_req.current_reg,
                    current_contract: this.loan_req.current_contract,
                    suppliers: a ? this.suppliers : null,
                    customers: b ? this.customers : null,
                };
                try {
                    this.$emit('load', 1);
                    const res = await apiPostGadTradeRef(form);
                    this.$emit('next');
                } catch (error) {
                    this.$emit('error', error);
                } finally {
                    this.$emit('load', -1);
                }
            },
            removeRowCus(index) {
                this.customers.splice(index, 1);
            },
            addRowCus() {
                this.customers.push({
                    name: null,
                    goods: null,
                    con_person: null,
                    con_number: null,
                });
            },
            removeRowSup(index) {
                this.suppliers.splice(index, 1);
            },
            addRowSup() {
                this.suppliers.push({
                    name: null,
                    goods: null,
                    con_person: null,
                    con_number: null,
                });
            },
        },
        computed: {},
        mounted() {}
    }
</script>